import Heading from '../Heading/Heading'
import * as styles from './PageTitle.module.scss'

const PageTitle = ({ title, text }) => (
  <div className={styles.pageTitleContainer}>
    <Heading type="h1" headingSize="display">
      {title}
    </Heading>
    {text}
  </div>
)

export default PageTitle
